import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLocation } from "../../store/location/selector";
import useViewModel from "./ViewModel";
import Keys from "../../constants/Keys";
import { selectProfile } from "../../store/profile/selector";
import { UserInterfaceState } from "../../shared/Enum";
import { useNavigate } from "react-router-dom";
import LoadingBackdrop from "../../shared/Components/LoadingBackdrop";
import { NavigateNext } from "@mui/icons-material";
import { setLocation } from "../../store/location/slice";
import { LoginContent } from "../../shared/Components/login";
import moment from "moment";
import { enqueueSnackbar } from "notistack";

export function HomePage() {
  /* eslint-disable no-restricted-globals */
  const { hash } = location;
  const navigate = useNavigate();
  const locationState = useSelector(selectLocation);
  const { data, method } = useViewModel();
  const profile = useSelector(selectProfile);
  const passportState = useSelector(selectProfile);
  const dispatch = useDispatch();

  const [locationId, setLocationId] = useState("");

  useEffect(() => {
    method.onGetLocationList();
  }, []);

  useEffect(() => {
    if (UserInterfaceState.isError(data.UIState)) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.UIState]);

  useEffect(() => {
    if (
      locationState.locationId &&
      data.locationList.some((e) => e.locationId === locationState.locationId)
    ) {
      setLocationId(locationState.locationId);
    } else if (data.locationList.length > 0) {
      setLocationId(data.locationList[0]?.locationId);
    }
  }, [data.locationList, locationState.locationId]);

  useEffect(() => {
    locationId &&
      method.onGetFormList({
        isBinusianOnly: !!profile,
        locationId,
      });
  }, [locationId, profile]);

  useEffect(() => {
    if (locationId !== "" && locationId !== null) {
      method.onGetLocationDetail(locationId);
    }
  }, [locationId]);

  useEffect(() => {
    if (data.locationDetail.locationName !== "") {
      dispatch(setLocation(data.locationDetail));
    }
  }, [data.locationDetail, dispatch]);

  useEffect(() => {
    if (hash) {
      /* eslint-disable unicorn/prefer-query-selector */
      const element = document.getElementById(hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  const imageUrl = `${
    Keys.Public_CDN
  }Sharepoint/previewImage?uri=https://publiccdn.sharepointonline.com/${
    Keys.SharePoint_BaseUrl
  }${locationState.imageUrl}?${moment()
    .add(3 - (moment().minute() % 3), "minutes")
    .startOf("minute")
    .format("DDMMYYYYHHmm")}`;

  return (
    <Box className="flex flex-col w-full">
      <Box className="flex flex-row">
        <FormControl className="flex flex-col md:flex-row w-full md:w-2/3 p-4 gap-4 md:gap-0">
          <Typography className="self-center text-sm font-bold w-full md:w-1/3">
            LOKASI BUILDING MANAGEMENT
          </Typography>
          <Select
            size="small"
            className="h-10 w-full md:w-2/3 font-bold"
            value={locationId}
            onChange={(e) => setLocationId(e.target.value)}
          >
            {data.locationList.map((e) => (
              <MenuItem key={e.locationId} value={e.locationId}>
                {e.locationName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!passportState && (
          <Box className="w-1/3 p-4 hidden md:flex justify-between">
            <Divider orientation="vertical" flexItem className="border-r-2" />
            <Typography className="self-center text-sm font-bold w-1/3">
              LOGIN BINUSIAN
            </Typography>
            <Box>
              <LoginContent buttonText="Sign in with Microsoft" />
            </Box>
          </Box>
        )}
      </Box>
      <Box
        // className="relative flex flex-col w-full h-screen bg-cover bg-center bg-opacity-100 px-10 md:px-32 text-white justify-center gap-8"
        className="relative flex flex-col w-full h-[calc(100vh-128px)] bg-cover bg-center text-white"
        style={{ backgroundImage: `url('${imageUrl}')` }}
        id="home"
      >
        <Box className="absolute inset-0 bg-black opacity-50" />
        <Box className="z-10 text-center h-full justify-end pb-24 gap-3 flex flex-col">
          <Typography className="text-3xl">WELCOME TO</Typography>
          <Typography className="text-5xl font-bold">
            BM HELP DESK {locationState.locationName}
          </Typography>
          <Typography className="text-lg">
            Efficient Solutions For a Seamless Campus Experience
          </Typography>
        </Box>
      </Box>
      <Box
        className="flex flex-col items-center py-12 gap-3 bg-primary-main"
        id="about-us"
      >
        <Box
          component="img"
          sx={{
            height: 100,
            width: 100,
          }}
          alt="About Us"
          src="/assets/icon/ic_about_us.png"
        />
        <Typography className="text-3xl font-semibold text-white">
          ABOUT US
        </Typography>
        <Typography className="py-10 px-48 text-white text-center hidden md:block">
          Welcome to the Building Management Help Desk at BINUS. Our mission is
          to maintain a safe, comfortable, and efficient environment for all
          students, staff, and visitors. Our dedicated team is committed to
          providing prompt assistance with a wide range of facility-related
          issues.
        </Typography>
        <Box className="flex flex-col md:flex-row justify-around w-full p-5 gap-5">
          <Card className="border-2 border-primary-main rounded-xl flex flex-col md:w-1/3 text-center p-6 gap-3 items-center">
            <CardMedia
              component="img"
              image="/assets/icon/ic_vision_bm_revamp.png"
              className="w-1/4"
            />
            <Typography className="text-2xl font-extrabold">Vision</Typography>
            <Typography>{locationState.vision}</Typography>
          </Card>
          <Card className="border-2 border-primary-main rounded-xl flex flex-col md:w-1/3 text-center p-6 gap-3 items-center">
            <CardMedia
              component="img"
              image="/assets/icon/ic_mission_bm_revamp.png"
              className="w-1/4"
            />
            <Typography className="text-2xl font-extrabold">Mission</Typography>
            <Grid container>
              {locationState.mission
                .slice(
                  0,
                  locationState.mission.length % 2 == 1
                    ? (locationState.mission.length - 1) / 2
                    : locationState.mission.length / 2
                )
                .map((e, i) => {
                  const dataIndex =
                    locationState.mission.length % 2 == 1
                      ? (locationState.mission.length - 1) / 2 + i
                      : locationState.mission.length / 2 + i;
                  return (
                    <>
                      <Grid item xs={6} className="flex p-2 text-left gap-2">
                        <Typography className="m-0">•</Typography>
                        <Typography>{e}</Typography>
                      </Grid>
                      <Grid item xs={6} className="flex p-2 text-left gap-2">
                        <Typography className="m-0">•</Typography>
                        <Typography>
                          {locationState.mission[dataIndex]}
                        </Typography>
                      </Grid>
                    </>
                  );
                })}
            </Grid>
            {locationState.mission.length % 2 == 1 && (
              <Box className="flex p-2 text-left gap-2 w-1/2">
                <Typography className="m-0">•</Typography>
                <Typography>
                  {locationState.mission[locationState.mission.length - 1]}
                </Typography>
              </Box>
            )}
          </Card>
          <Card className="border-2 border-primary-main rounded-xl flex flex-col md:w-1/3 text-center p-6 gap-3 items-center">
            <CardMedia
              component="img"
              image="/assets/icon/ic_strategy_bm_revamp.png"
              className="w-1/4"
            />
            <Typography className="text-2xl font-extrabold">
              Strategy
            </Typography>
            <Grid container>
              {locationState.strategy
                .slice(
                  0,
                  locationState.strategy.length % 2 == 1
                    ? (locationState.strategy.length - 1) / 2
                    : locationState.strategy.length / 2
                )
                .map((e, i) => {
                  const dataIndex =
                    locationState.strategy.length % 2 == 1
                      ? (locationState.strategy.length - 1) / 2 + i
                      : locationState.strategy.length / 2 + i;
                  return (
                    <>
                      <Grid item xs={6} className="flex p-2 text-left gap-2">
                        <Typography className="m-0">•</Typography>
                        <Typography>{e}</Typography>
                      </Grid>
                      <Grid item xs={6} className="flex p-2 text-left gap-2">
                        <Typography className="m-0">•</Typography>
                        <Typography>
                          {locationState.strategy[dataIndex]}
                        </Typography>
                      </Grid>
                    </>
                  );
                })}
            </Grid>
            {locationState.strategy.length % 2 == 1 && (
              <Box className="flex p-2 text-left gap-2 w-1/2">
                <Typography className="m-0">•</Typography>
                <Typography>
                  {locationState.strategy[locationState.strategy.length - 1]}
                </Typography>
              </Box>
            )}
          </Card>
        </Box>
      </Box>
      <Box
        className="flex flex-col items-center py-12 gap-4 px-5"
        id="services"
      >
        <Box
          component="img"
          sx={{
            height: 100,
            width: 100,
          }}
          alt="About Us"
          src="/assets/icon/ic_services.png"
        />
        <Typography className="text-3xl font-bold text-center">
          Our Services
        </Typography>
        <Typography className="hidden md:block">
          Maintenance, safety, permit, emergencies, equipment, inquiries.
        </Typography>
        <Grid container spacing={3} className="mt-3">
          {data.formList.map((e) => (
            <Grid item xs={12} md={4} className="flex">
              <Card className="flex flex-col w-full border-2">
                <CardMedia
                  component="img"
                  image={`${Keys.Public_CDN}Sharepoint/previewImage?uri=https://publiccdn.sharepointonline.com/${Keys.SharePoint_BaseUrl}${e.imageUrl}`}
                  className="h-56 w-full"
                />
                <CardContent
                  className="justify-between flex flex-col h-1/2 p-2 gap-4"
                  sx={{ "&:last-child": { pb: 1 } }}
                >
                  <Box className="flex flex-col gap-2">
                    <Typography className="text-2xl font-semibold">
                      {e.name}
                    </Typography>
                    <Typography className="text-sm">{e.description}</Typography>
                  </Box>
                  <Box className="flex">
                    <Typography
                      className="text-sm text-primary-main cursor-pointer"
                      onClick={() => {
                        const toOpen = window.open(
                          e.link,
                          "_blank",
                          "noopener,noreferrer"
                        );
                        if (toOpen) toOpen.opener = null;
                      }}
                    >
                      Request this Service{" "}
                      <NavigateNext className="font-bold" />
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <LoadingBackdrop isOpen={UserInterfaceState.isLoading(data.UIState)} />
    </Box>
  );
}
